import React, { Component } from 'react';
import Loading from '../../../../components/Loading';
import ReactModal from '../../../../components/Modal';
import { withTranslation } from 'react-i18next';
import { bulkAddTags } from '../query';

class AddTags extends Component {
    constructor() {
        super();

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);

        this.state = {
            isLoading: false,
        };
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            errors: {},
        });
    }

    async onSubmit() {
        try {
            this.setState({ isLoading: true, error: '' });
            const tags = this.state.tagInputValue
                .split(',')
                .map((tag) => tag.trim())
                .filter((tag) => tag !== '');
            const body = {
                ids: this.props.selectedItems,
                tags_to_add: tags,
                tags_to_remove: [],
            };
            const response = await bulkAddTags(body);
            const data = await response.json();
            if (response.status === 200) {
                if (this.props.getPrompts) this.props.getPrompts();
                this.props.onClose();
                this.props.onRemoveAllSelected(true);
            } else {
                this.setState({
                    error: data?.detail ?? this.props.t('global.something_went_wrong'),
                });
            }
            this.setState({ isLoading: false });
        } catch (err) {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="ai-tracking-edit-keyword-container ai-tracking-modal add-tags-modal"
                onClose={this.props.onClose}
            >
                <h3>{t('ai_tracking.add_keyword.add_tags')}</h3>
                <div className="ai-tracking-edit-keyword-container-body ai-tracking-modal-body px-12">
                    <label className="ai-tracking-create-label">
                        {t('ai_tracking.add_keyword.add_tags')}
                        <span className="text-danger">*</span> <br />
                        <small>{t('ai_tracking.add_keyword.add_tags_description')}</small>
                    </label>
                    <input
                        className="form-control"
                        name="tagInputValue"
                        value={this.state.tagInputValue}
                        onChange={this.onChange}
                    />
                    {this.state.error && <div className="error-message">{this.state.error}</div>}
                </div>
                <div className="btn-wrapper ai-tracking-modal-footer">
                    <button
                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                        disabled={this.state.isLoading || !this.state.tagInputValue?.trim()}
                        onClick={this.onSubmit}
                    >
                        <span style={{ marginRight: '5px' }}>
                            {t('ai_tracking.keyword_manager.edit_keyword.save')}
                        </span>
                        {this.state.isLoading && <Loading onlyPreloader />}
                    </button>
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={this.props.onClose}
                        style={{ lineHeight: 'unset' }}
                    >
                        {t('ai_tracking.keyword_manager.edit_keyword.close')}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(AddTags);
